import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PdfOrImageUploader from '../../../pdfImage uploader';
import ErrorMessage from '../../../form/ErrorMessage';
import { jobPostSchema } from '../../../../utils/schema';
import { Formik } from 'formik';
import Loader from '../../../loader';
import { addJobPostByHireTalent, getJobPostData, updateJobPostByHireTalent } from '../../../../redux/features/hire-talent/actions/authAction';
import { pipViewDate, pipViewDate3 } from '../../../../utils/pip';
import TagInput from '../../../form/TagInput';

const PostNewJob = ({ onClose, title, jobPostDetails, isJobPostUpdate }) => {
    const dispatch = useDispatch();
    const { subLoading } = useSelector((state) => state.hireTalent.auth);

    const initialValues = {
        job_title: jobPostDetails?.job_title || "",
        location: jobPostDetails?.location || "",
        industry: jobPostDetails?.industry || "",
        category: jobPostDetails?.category || "",
        candidate_location: jobPostDetails?.candidate_location || "",
        candidate_availability: jobPostDetails?.candidate_availability || "",
        job_description: jobPostDetails?.job_description || "",
        about_role: jobPostDetails?.about_role || "",
        license: jobPostDetails?.license || "",
        years_of_experience: jobPostDetails?.years_of_experience || "",
        minimum_education: jobPostDetails?.minimum_education || "",
        salary_currency: jobPostDetails?.salary_currency || "",
        min_salary: jobPostDetails?.min_salary || "",
        max_salary: jobPostDetails?.max_salary || "",
        responsibility: jobPostDetails?.responsibility || "",
        education: jobPostDetails?.education || "",
        start_date: jobPostDetails?.start_date ? pipViewDate3(jobPostDetails?.start_date) : "",
        end_date: jobPostDetails?.end_date ? pipViewDate3(jobPostDetails?.end_date) : "",
        status: jobPostDetails?.status || "Draft",
        skills: jobPostDetails?.skills
            ? jobPostDetails?.skills.split(",")
            : [],
        qualification: jobPostDetails?.qualification ? jobPostDetails?.qualification.split(",") : [],
        requirement: jobPostDetails?.requirement ? jobPostDetails?.requirement.split(",") : [],
    };

    const hanldeCreateContent = (values) => {
        const callback = (response) => {
            dispatch(getJobPostData());
            onClose();
        };
        values.end_date == "" && delete values.end_date;
        values.skills = values?.skills?.join(",");
        values.qualification = values?.qualification?.join(",");
        values.requirement = values?.requirement?.join(",");
        if (isJobPostUpdate) {
            dispatch(updateJobPostByHireTalent({ payload: values, callback, params: jobPostDetails?.id }));
        } else {
            dispatch(addJobPostByHireTalent({ payload: values, callback }));
        };
    };

    if (subLoading) {
        return <Loader />;
    };
    return (
        <div
            className="modal d-block ct_congratulation_modal_fade ct_reactivate_account"
            tabIndex="-1"
        >
            <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <h4 className="ct_fs_16 ct_darkblue_text mb-0">{title || ""}</h4>
                        <button
                            type="button"
                            className="btn-close ct_circle_close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div className="modal-body px-0 ct_mt_20 pt-0">
                        <Formik
                            initialValues={initialValues}
                            validationSchema={jobPostSchema}
                            onSubmit={(values, actions) => {
                                hanldeCreateContent(values);
                            }}
                            enableReinitialize
                        >
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                setFieldValue,
                                setTouched,
                            }) => (
                                <form className="ct_modal_scroll ct_custom_scroll px-4 pb-3 ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Job Title
                                                </label>
                                                <input
                                                    value={values?.job_title}
                                                    id="job_title"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    type="text"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Enter Job Title"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"job_title"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Location
                                                </label>
                                                <input
                                                    value={values?.location}
                                                    id="location"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    type="text"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Enter location"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"location"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Industry
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.industry}
                                                        id="industry"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}> Select Industry</option>
                                                        <option value={"Information Technology (IT) & Software"}>Information Technology (IT) & Software </option>
                                                        <option value={"Finance & Banking"}>Finance & Banking </option>
                                                        <option value={"Healthcare & Pharmaceuticals"}>Healthcare & Pharmaceuticals </option>
                                                        <option value={"Education & Training"}>Education & Training </option>
                                                        <option value={"Engineering & Manufacturing"}>Engineering & Manufacturing </option>
                                                        <option value={"Retail & E-commerce"}>Retail & E-commerce </option>
                                                        <option value={"Hospitality & Tourism"}>Hospitality & Tourism </option>
                                                        <option value={"Marketing, Media & Communications"}>Marketing, Media & Communications </option>
                                                        <option value={"Transportation & Logistics"}>Transportation & Logistics </option>
                                                        <option value={"Energy & Utilities"}>Energy & Utilities </option>
                                                        <option value={"Legal Services"}>Legal Services </option>
                                                        <option value={"Agriculture & Food Industry"}>Agriculture & Food Industry </option>
                                                        <option value={"Government & Public Sector"}>Government & Public Sector </option>
                                                        <option value={"Nonprofit & NGOs"}>Nonprofit & NGOs </option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"industry"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Category
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.category}
                                                        id="category"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}>Select Category</option>
                                                        <option value={"Professional growth"}>Professional growth</option>
                                                        <option value={"Career evolution"}>Career evolution</option>
                                                        <option value={"Meaningful Impact"}>Meaningful Impact</option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"category"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Candidate Location
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.candidate_location}
                                                        id="candidate_location"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}> Select Candidate Location</option>
                                                        <option value={"On-site"}>On-site </option>
                                                        <option value={"Remote"}>Remote </option>
                                                        <option value={"Hybrid"}>Hybrid </option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"candidate_location"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Candidate Availability
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.candidate_availability}
                                                        id="candidate_availability"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}> Select Candidate Availability</option>
                                                        <option value={"Full Time"}>Full Time </option>
                                                        <option value={"Part Time"}>Part Time </option>
                                                        <option value={"Freelance"}>Freelance </option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"candidate_availability"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    License
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.license}
                                                        id="license"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}> Select License</option>
                                                        <option value={"Required"}>Required </option>
                                                        <option value={"Not Required"}>Not Required </option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"license"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Job Description
                                                </label>
                                                <textarea
                                                    value={values?.job_description}
                                                    id="job_description"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    className="form-control ct_input h-auto ct_fs_12"
                                                    rows={4}
                                                    placeholder="Enter Job Description"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"job_description"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    About role
                                                </label>
                                                <textarea
                                                    value={values?.about_role}
                                                    id="about_role"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    className="form-control ct_input h-auto ct_fs_12"
                                                    rows={4}
                                                    placeholder="Enter About this role"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"about_role"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Responsibility
                                                </label>
                                                <textarea
                                                    value={values?.responsibility}
                                                    id="responsibility"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    className="form-control ct_input h-auto ct_fs_12"
                                                    rows={4}
                                                    placeholder="Enter responsibility"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"responsibility"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Education
                                                </label>
                                                <textarea
                                                    value={values?.education}
                                                    id="education"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    className="form-control ct_input h-auto ct_fs_12"
                                                    rows={4}
                                                    placeholder="Enter education"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"education"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Years of Experience
                                                </label>
                                                <input
                                                    value={values?.years_of_experience}
                                                    id="years_of_experience"
                                                    name="years_of_experience"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                            handleChange(e);
                                                        }
                                                    }}
                                                    type="text"
                                                    inputMode="decimal"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Enter year of experience"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"years_of_experience"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Educational Qualification
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.minimum_education}
                                                        id="minimum_education"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}> Select Educational Qualification</option>
                                                        <option value={"No formal degree / Self-taught"}> No formal degree / Self-taught</option>
                                                        <option value={"High School / Secondary Education"}>High School / Secondary Education</option>
                                                        <option value={"Diploma / Associate Degree"}> Diploma / Associate Degree</option>
                                                        <option value={"Bachelor’s Degree"}> Bachelor’s Degree</option>
                                                        <option value={"Master’s Degree"}> Master’s Degree</option>
                                                        <option value={"MBA / Executive Degree"}> MBA / Executive Degree</option>
                                                        <option value={"Doctorate (PhD)"}> Doctorate (PhD)</option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"minimum_education"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Salary Currency
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.salary_currency}
                                                        id="salary_currency"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={""}> Select Salary Currency</option>
                                                        <option value={"$"}>US Dollar ($)</option>
                                                        <option value={"MUR"}>Mauritian Rupee (MUR)</option>
                                                        <option value={"INR"}>Indian Rupee (INR)</option>
                                                        <option value={"£"}>British Pound (£)</option>
                                                        <option value={"AUD"}>Australian Dollar (AUD)</option>
                                                        <option value={"CAD"}>Canadian Dollar (CAD)</option>
                                                        <option value={"CNY"}>Chinese Yuan (CNY)</option>
                                                        <option value={"AED"}>UAE Dirham (AED)</option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"salary_currency"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Minimum Salary / Year
                                                </label>
                                                <input
                                                    value={values?.min_salary}
                                                    id="min_salary"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    type="number"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Enter Minimum Salary"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"min_salary"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Maximum Salary / Year
                                                </label>
                                                <input
                                                    value={values?.max_salary}
                                                    id="max_salary"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    type="number"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Enter Maximum Salary"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"max_salary"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Start Date
                                                </label>
                                                <input
                                                    value={values?.start_date}
                                                    id="start_date"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    min={new Date().toISOString().split("T")[0]}
                                                    type="date"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Please select Start Date"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"start_date"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    End Date (Optional)
                                                </label>
                                                <input
                                                    value={values?.end_date}
                                                    id="end_date"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    min={new Date().toISOString().split("T")[0]}
                                                    type="date"
                                                    className="form-control ct_fs_12 ct_input"
                                                    placeholder="Please select end date"
                                                />
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"end_date"}
                                                />
                                            </div>
                                        </div>
                                        <TagInput
                                            label="Skills"
                                            placeholder="Type to add skills..."
                                            name="skills"
                                            value={values?.skills}
                                            onChange={setFieldValue}
                                            error={touched?.skills && errors?.skills}
                                        />
                                        <TagInput
                                            label="Qualification"
                                            placeholder="Type to add qualification..."
                                            name="qualification"
                                            value={values?.qualification}
                                            onChange={setFieldValue}
                                            error={touched?.qualification && errors?.qualification}
                                        />
                                        <TagInput
                                            label="Requirement"
                                            placeholder="Type to add requirement..."
                                            name="requirement"
                                            value={values?.requirement}
                                            onChange={setFieldValue}
                                            error={touched?.requirement && errors?.requirement}
                                        />
                                        <div className="col-md-12">
                                            <div className="form-group mb-4">
                                                <label className="ct_fs_14 ct_darkblue_text mb-2">
                                                    Status
                                                </label>
                                                <div className="d-flex flex-column gap-2 position-relative">
                                                    <select
                                                        className="form-control ct_fs_12 ct_input"
                                                        value={values?.status}
                                                        id="status"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                    >
                                                        <option value={"Draft"}>Draft </option>
                                                        <option value={"Active"}>Active </option>
                                                    </select>
                                                    <i class="fa-solid fa-angle-down ct_show_eye ct_pointer_events_none"></i>
                                                </div>
                                                <ErrorMessage
                                                    errors={errors}
                                                    touched={touched}
                                                    fieldName={"status"}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-3 justify-content-end pt-4">
                                        <button
                                            className="ct_sky_blue_btn ct_fs_14 ct_yellow_btn ct_outline_grey  px-5 py-2"
                                            style={{ borderColorL: "#53586252" }}
                                            type="button"
                                            onClick={onClose}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            onClick={handleSubmit}
                                            className=" ct_yellow_btn px-5 ct_fs_14 py-2"
                                            type="button"
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PostNewJob;